module.exports = __webpack_public_path__ + "static/media/background-mobile.3bbe356d.jpg";